<template>
  <li class="q-pt-1 multi-range__container">
    <div class="q-d-flex q-justify-content-between q-pb-3 multi-range__item">
      <small class="q-small multi-range__min-container">
        <span class="multi-range__min-text">{{ SmartSearchTranslations.filters.from }}: </span>
        <span class="multi-range__min-value">{{ format(filterData.min) }}</span>
      </small>
      <small class="q-small multi-range__max-container">
        <span class="multi-range__max-text q-ps-2">{{ SmartSearchTranslations.filters.to }}: </span>
        <span class="multi-range__max-value">{{ format(filterData.max) }}</span>
      </small>
    </div>
    <Slider :class="'q-px-3'" v-model="range" :format="format" :min="minInputValue" :max="maxInputValue"
            @end="updateRangeValue"
    />
  </li>
</template>

<script setup lang="ts">
import Slider from '@vueform/slider'
import {defineProps, ref, watch, inject, defineEmits} from 'vue';
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
import {SmartSearchConfig} from "@/main";
import {formatPrice} from "@/core/utils";
import {SmartSearchTranslationsInterface} from "@/core/types";

const filtersStore = useFiltersStore()

const props = defineProps(['filterData', 'field'])
const minInputValue = ref<number | null>(props.filterData.min);
const maxInputValue = ref<number | null>(props.filterData.max);
const unit = ref(props.filterData.unit)
const serpStore = useSerpResultsStore()
const {getCurrencyCode} = storeToRefs(serpStore)
const {removeDecimals} = SmartSearchConfig.value.appConfiguration
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


const format = (value: number) => {
  if (props.field === 'price') {
    return formatPrice(value, getCurrencyCode.value, removeDecimals)
  }
  return `${value.toFixed()} ${unit.value ?? ''}`;
};
const range = ref([minInputValue.value, maxInputValue.value]);

const emit = defineEmits(['closeDropdown']);
const updateRangeValue = (newValues: Array<number>) => {
  const minValue = newValues[0]
  const maxValue = newValues[1]
  setTimeout(() => {
    filtersStore.updateRangeFilter(props.field, minValue, maxValue);
    emit('closeDropdown');
  }, 400)

}
watch(props.filterData, () => {
  filtersStore.updateRangeFilter(props.field, Number(minInputValue.value), Number(maxInputValue.value));
}, {immediate: false});


</script>

<style src="@vueform/slider/themes/default.css"></style>
<style>
:root {
  --slider-connect-bg: #dc3545;
  --slider-tooltip-bg: #dc3545;
  --slider-handle-ring-color: #dc3545;
}

.slider-handle.slider-handle-upper .slider-tooltip-top, .slider-handle.slider-handle-lower .slider-tooltip-top {
  display: none;
}

.slider-handle.slider-handle-upper.slider-active .slider-tooltip-top, .slider-handle.slider-handle-lower.slider-active .slider-tooltip-top {
  display: unset !important;
}

.dropdown .serp__filter-item--rangeSlider {
  overflow: visible !important;
}

.dropdown .multi-range__max-container {
  margin-left: 0.5rem;
}

</style>